// extracted by css-extract-rspack-plugin
export default {"formElement":"formElement__qSLym","voiceControlCheckboxDescription":"voiceControlCheckboxDescription__eWZoA"};